// extracted by mini-css-extract-plugin
export var merchItem = "item-module--merchItem--w8EJq";
export var merchItem__img = "item-module--merchItem__img--BVk8s";
export var merchItem__price = "item-module--merchItem__price--EEvHQ";
export var merchItem__text = "item-module--merchItem__text--xRcvh";
export var merchItem__text_vertical = "item-module--merchItem__text_vertical--9APBg";